import { render } from "./EntityModalContainerProduction.vue.js?vue&type=template&id=bc4c4960!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EntityModalContainerProduction.vue?vue&type=template&id=bc4c4960"
import script from "./EntityModalContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EntityModalContainerProduction.vue?vue&type=script&lang=js"
export * from "./EntityModalContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EntityModalContainerProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/entity-modal/EntityModalContainerProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc4c4960"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc4c4960', __exports__)) {
    api.reload('bc4c4960', __exports__)
  }
  
  module.hot.accept("./EntityModalContainerProduction.vue.js?vue&type=template&id=bc4c4960!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EntityModalContainerProduction.vue?vue&type=template&id=bc4c4960", () => {
    api.rerender('bc4c4960', render)
  })

}


export default __exports__